import { Component, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { UrlsConstants } from 'src/app/core/constants/urls.constants';
import { AuthActions } from 'src/app/modules/login/store/auth.actions';
import { AuthSelectors } from 'src/app/modules/login/store/auth.selectors';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss']
})
export class ProfileMenuComponent implements OnDestroy {

  @Select(AuthSelectors.getUserName) username$: Observable<String>;

  private unsubscriber$ = new Subject<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private store: Store
  ) {
    let username = this.store.selectSnapshot(AuthSelectors.getUserName);
    if(!username) {
      this.store.dispatch(new AuthActions.SetUser());
    }
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }

  getLoginRouterLink(){
    let isMonitorPage: boolean = window.location.pathname.indexOf(UrlsConstants.MONITOR_PATH) >= 0; 
    if (isMonitorPage) {
    return `/${UrlsConstants.MONITOR_PATH}/${UrlsConstants.LOGIN_PATH}`;
    }
    return `/${UrlsConstants.LOGIN_PATH}`;
  }

  logout() {
    if(this.username$){
       this.authenticationService.logout();
    }
  }
}
